import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../../lib/components/grid";
import Confirmation from "../../lib/components/confirmation";

import { target, targetsAll } from "../../lib/api/target";
import { GridColumns } from "./targetsgridsetup";

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";

import IconAdd from "@material-ui/icons/Add";

import TargetsEditForm from "./targetseditform";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Toolbar from "@material-ui/core/Toolbar";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "100%",
      height: "100%",
      position: "relative",
    },
    toolbar: {
      position: "absolute",
      left: 0,
      width: "100%",
      gap: `${theme.spacing(1)}px`,
    },
  });

type TargetsProps = {} & WithStyles<typeof styles>;

export class TargetsUnstyled extends React.Component<TargetsProps, any> {
  state = {
    classes: undefined,
    data: [],
    confirmRemoveID: undefined,
    confirmEditID: undefined,
    loading: true,
    showInactive: true,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    targetsAll().then((data) => {
      const dataSorted = data.data.sort((a, b) => {
        if (a.region > b.region) return 1;
        if (a.region < b.region) return -1;
        return 1;
      });
      this.setState({ loading: false, data: dataSorted });
    });
  };

  handleCreate = () => {
    this.setState({ confirmEditID: "0" });
  };

  handleEdit = (id) => {
    this.setState({ confirmEditID: id });
  };

  handleEditClose = () => {
    this.setState({ confirmEditID: undefined });
  };

  handleEditConfirm = async (item) => {
    const id = item["id"];
    delete item["id"];

    if (parseInt(id)) {
      await target.update(id, {
        data: {
          active: item.active,
          region: item.region,
          market: item.market,
          country: item.country,
          description: item.description,
          currency: item.currency,
        },
      });
    } else {
      await target.create({
        data: {
          active: item.active,
          region: item.region,
          market: item.market,
          country: item.country,
          description: item.description,
          currency: item.currency,
        },
      });
    }
    this.loadData();
    this.handleEditClose();
  };

  handleRemove = async (id) => {
    this.setState({ confirmRemoveID: id });
  };

  handleRemoveClose = () => {
    this.setState({ confirmRemoveID: undefined });
  };

  handleRemoveConfirm = async () => {
    await target.remove(this.state.confirmRemoveID).then(() => {
      this.handleRemoveClose();
      this.loadData();
    });
  };

  GridColumnsOverride = (column, row) => {
    return GridColumns(column, row, this.handleRemove, this.handleEdit);
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <div style={{ position: "relative" }}>
          <Toolbar className={classes.toolbar}>
            <Tooltip title="Create new Target">
              <Button variant="contained" color="primary" onClick={this.handleCreate} style={{ marginBottom: "10px" }}>
                <IconAdd />
              </Button>
            </Tooltip>
            {/* <FormControlLabel
              style={{ marginLeft: "20px" }}
              control={
                <Switch
                  inputProps={{ "aria-label": "primary checkbox" }}
                  checked={this.state.showInactive}
                  onChange={() => this.setState({ showInactive: !this.state.showInactive })}
                />
              }
              label="Show Inactive Targets"
            /> */}
          </Toolbar>
          <Grid
            loading={this.state.loading}
            data={this.state.data.filter((t) => (this.state.showInactive ? t.active === 0 || t.active : t.active))}
            GridColumns={this.GridColumnsOverride}
            clearFilters={"targetsgridsetup"}
          />
        </div>
        {this.state.confirmRemoveID && (
          <Confirmation
            isOpen={this.state.confirmRemoveID ? true : false}
            handleClose={this.handleRemoveClose}
            handleConfirm={this.handleRemoveConfirm}
            title="Remove selected Target?"
            body="Are you sure you want to REMOVE the selected Target Record?"
          ></Confirmation>
        )}
        {this.state.confirmEditID && (
          <Confirmation
            isOpen={this.state.confirmEditID ? true : false}
            handleClose={this.handleEditClose}
            handleConfirm={() => {}}
            title={this.state.confirmEditID == "0" ? "Creating Target" : "Editing Target"}
            body={undefined}
          >
            <TargetsEditForm onSubmit={this.handleEditConfirm} onClose={this.handleEditClose} id={this.state.confirmEditID} />
          </Confirmation>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(TargetsUnstyled);
